import { useEffect, useState } from "react";
import { BookOpen, PenLine, Search, Sparkles } from "lucide-react";
import type { Session } from "../../api/types.js";
import type { WorkspaceView } from "../workspace/workspaceView.js";
import { SessionTitleText } from "./SessionTitleText.js";

export function SidebarNav({
  collapsed,
  activeView,
  currentSession,
  sessions,
  onNewSession,
  onOpenSearch,
  onOpenSkills,
  onOpenSession
}: {
  collapsed: boolean;
  activeView: WorkspaceView;
  currentSession: Session | null;
  sessions: Session[];
  onNewSession: () => void;
  onOpenSearch: () => void;
  onOpenSkills: () => void;
  onOpenSession: (session: Session) => void;
}) {
  const [railHistoryOpen, setRailHistoryOpen] = useState(false);
  const recentRailSessions = sessions.slice(0, 10);

  useEffect(() => {
    if (!collapsed) setRailHistoryOpen(false);
  }, [collapsed]);

  return (
    <div className="sidebar-fixed-actions">
      <button className={`nav-item ${activeView === "chat" && !currentSession ? "active" : ""}`} type="button" onClick={onNewSession} data-tooltip="新聊天">
        <PenLine size={18} />
        <span>新聊天</span>
      </button>
      <button className={`nav-item ${activeView === "search" ? "active" : ""}`} type="button" onClick={onOpenSearch} data-tooltip="搜索">
        <Search size={18} />
        <span>搜索</span>
      </button>
      <button className={`nav-item ${activeView === "skills" ? "active" : ""}`} type="button" onClick={onOpenSkills} data-tooltip="技能">
        <Sparkles size={18} />
        <span>技能</span>
      </button>
      <button
        className="nav-item rail-only"
        type="button"
        data-tooltip="最近聊天"
        data-open-recent-chats
        aria-expanded={railHistoryOpen}
        aria-controls="railHistoryPopover"
        onClick={() => setRailHistoryOpen((old) => !old)}
      >
        <BookOpen size={18} />
        <span>最近聊天</span>
      </button>
      <div className="rail-history-popover" id="railHistoryPopover" hidden={!railHistoryOpen || !collapsed}>
        <strong>最近聊天</strong>
        <div className="history-list">
          {recentRailSessions.length === 0 && <p>暂无最近对话</p>}
          {recentRailSessions.map((session) => (
            <button
              key={session.id}
              className={`history-item ${session.id === currentSession?.id ? "active" : ""}`}
              type="button"
              aria-label={session.title}
              onClick={() => {
                setRailHistoryOpen(false);
                onOpenSession(session);
              }}
            >
              <BookOpen size={16} />
              <SessionTitleText title={session.title} source={session.titleSource} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
